/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_LapsedInputs */



/**
* | output |
* | --- |
* | "This term ended on {date} before it ever started, so it can no longer be approved or switched on. Cancel it to close the deal; the organization stays suspend..." |
*
* @param {Partner_Org_Contract_LapsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_lapsed = /** @type {((inputs: Partner_Org_Contract_LapsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_LapsedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Laufzeit endete am ${i?.date}, bevor sie je begonnen hat, und kann daher nicht mehr freigegeben oder aktiviert werden. Stornieren Sie sie, um den Vorgang abzuschließen; die Organisation bleibt gesperrt, bis jemand sie entsperrt.`)
	return /** @type {LocalizedString} */ (`This term ended on ${i?.date} before it ever started, so it can no longer be approved or switched on. Cancel it to close the deal; the organization stays suspended until someone unfreezes it.`)
});